import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { PowerbiReportComponent } from '@next/core-lib/powerbi-embedded';
import { Environment } from 'src/environments/environment.model';

@Component({
  selector: 'app-regenerative-agriculture',
  templateUrl: './regenerative-agriculture.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PowerbiReportComponent],
})
export class RegenerativeAgricultureComponent {
  private readonly env = inject<Environment>(EnvironmentInjector);

  public readonly workspaceId: string;
  public readonly reportId: string;

  constructor() {
    this.workspaceId = this.env.REGENERATIVE_AGRICULTURE_WORKSPACE_ID;
    this.reportId = this.env.REGENERATIVE_AGRICULTURE_REPORT_ID;
  }
}
